import { render } from "./CreateNew.vue?vue&type=template&id=3da4d102&scoped=true"
import script from "./CreateNew.vue?vue&type=script&lang=js"
export * from "./CreateNew.vue?vue&type=script&lang=js"

import "./CreateNew.vue?vue&type=style&index=0&id=3da4d102&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da4d102"]])

export default __exports__